import chatbanner from "src/assets/Chatbanner.png";

const AppBanner = () => {
  return (
    <div className="rounded-2xl translate-y-80 md:translate-y-0  fixed inset-0 my-4  h-[45vh] md:h-[calc(100vh-17%)] w-full md:w-[72vw]  transition-transform duration-300 md:translate-x-[26vw] mt-32 flex justify-center items-center">
      <div className="flex flex-col justify-center items-center ">
        <img src={chatbanner} alt="Chat Banner" className="w-[250px] md:w-[300px] lg:w-[350px] xl:w-[400px] h-auto" />
        <h1 className="text-[#222222] font-medium text-[25px] md:text-[32px] mt-6 ">Let’s Change Lives</h1>
        <h6 className="text-[#76767C] text-[12px] md:text-[15px]  font-normal ">One message, one connection, and one act of kindness at a time</h6>
      </div>
    </div>
  );
};

export default AppBanner;
